export interface FieldProps {
  noPadding?: boolean;
  children?: React.ReactNode;
  divider?: 'auto' | boolean;
}
